import { render, staticRenderFns } from "./ticketopen.vue?vue&type=template&id=0f534d44&scoped=true"
import script from "./ticketopen.vue?vue&type=script&lang=js"
export * from "./ticketopen.vue?vue&type=script&lang=js"
import style0 from "./ticketopen.vue?vue&type=style&index=0&id=0f534d44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f534d44",
  null
  
)

export default component.exports